import { render, staticRenderFns } from "./pollution.vue?vue&type=template&id=f9ab8d34&"
import script from "./pollution.vue?vue&type=script&lang=js&"
export * from "./pollution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports